export default "__VITE_ASSET__8XFi$aq___"